import * as globalTypes from '@/store/mutation-types.js'
import icons from '@/mixins/icons.js'
import basicOperations from '@/mixins/basic-operations.js'

export default {
  name: 'ChiefMenu',
  mixins: [icons, basicOperations],
  computed: {
    leftMenubarItem () {
      if(this.$store.state.menubarItems.left.length > 0&& this.$store.state.menubarItems.left[0].FUNCTIE !== 'menuTogglen'){
        return this.$store.state.menubarItems.left[0]
      }
      return 0
    },
    menubarItems () {
      return this.$store.state.menubarItems
    },
    mainMenuItems () {
      return this.$store.state.mainMenuItems.filter(function (item) {
        return !item.isStudentForParent
      })
    },
    studentsForParent () {
      return this.$store.state.mainMenuItems.filter(function (item) {
        return item.isStudentForParent
      })
    },
    isOuder () {
      return this.$store.state.userInfo.isOuder
    },
    showMenu () {
      return this.$store.state.flags.showMenu
    },
    username () {
      return this.$store.state.userInfo.loggedInConnectionObject ? this.$store.state.userInfo.loggedInConnectionObject.username : ''
    }
  },
  data () {
    return {
      currentPath: '/'
    }
  },
  watch: {
    // call again the method if the route changes
    $route: 'fetchData'
  },
  methods: {
    fetchData () {
      this.currentPath = this.$router.history.current.path
    },
  
    isCurrentPath (item) {
      try {
        return this.$store.state.activeModule.toLowerCase() === item.name.toLowerCase() // .split('/')[1]
      } catch (e) {
        return false
      }
    },
    isStudentSelected (student) {
      return student.ID === this.$store.state.oudersSpecific.selectedKid.ID
    },
    clickedOnHome () {
      this.arrangeModuleFlags('Landing Page')
      this._goTo('landing-page')
    },
    clickedOnInfo () {
      this.arrangeModuleFlags('Info')
      this._goTo('info')
    },
    arrangeModuleFlags (moduleName) {
      this.$store.commit(globalTypes.MODULE_CHANGING_USING_MAIN_MENU, true)
      this.$store.commit(globalTypes.SET_ACTIVE_MODULE, moduleName)
    },
    redirectFunctie (item, event) {
      this.arrangeModuleFlags(item.name)
      this.$router.push(item.path)
      if (typeof item.cbFunction !== 'undefined') {
        item.cbFunction()
      }
    },
    exeRsmFunction (rsmItem) {
      console.log(rsmItem)
      console.log(rsmItem.FUNCTIE)
      if(rsmItem.FUNCTIE === 'goBack'){
        this._goBack()
      }
      else if(rsmItem.FUNCTIE){
        rsmItem.FUNCTIE()
      }
    },
    logout () {
      this.$store.dispatch('logout')
    }
  }
}
